import { render, staticRenderFns } from "./PhoneRecommendCard.vue?vue&type=template&id=3b7f8a05&scoped=true&"
import script from "./PhoneRecommendCard.vue?vue&type=script&lang=ts&"
export * from "./PhoneRecommendCard.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneRecommendCard.vue?vue&type=style&index=0&id=3b7f8a05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f8a05",
  null
  
)

export default component.exports